import React from "react";

const FooterEdicao = ({ form, onSalvar, onVoltar }) => {
  const isUpdate = !!form.getFieldValue(["dependente", "id"]);

  return (
    <div className="footer-dependente p-3">
      <button
        type="button"
        className="btn btn-outline-dark"
        onClick={onSalvar}
      >
        {isUpdate ? (
          <>
            <i className="fas fa-edit me-2" />
            Atualizar Dependente
          </>
        ) : (
          <>
            <i className="fas fa-plus me-2" />
            Inserir Dependente
          </>
        )}
      </button>

      <button
        type="button"
        className="btn btn-outline-dark"
        onClick={onVoltar}
      >
        <i className="fas fa-arrow-left me-2" />
        Voltar à Lista
      </button>
    </div>
  );
};

export default FooterEdicao;
